import type { TranscriptionStreamText } from "@/hooks/transcriber/types";
import { create } from "zustand";

export interface TranscriptionStreamingState {
  transcriptionStreamText: TranscriptionStreamText[];
  setStreamText: (data: TranscriptionStreamText) => void;
  resetStreamText: () => void;
  finishSteamText: () => void;
  isLoading: boolean;
}

export const useTranscriptionStreamingStore =
  create<TranscriptionStreamingState>()((set, get) => ({
    transcriptionStreamText: [],
    isLoading: false,
    setStreamText: (data: TranscriptionStreamText): void => {
      set({
        isLoading: true,
        transcriptionStreamText: [...get().transcriptionStreamText, data],
      });
    },
    resetStreamText: (): void => {
      set({
        isLoading: false,
        transcriptionStreamText: [],
      });
    },
    finishSteamText: (): void => {
      set({
        isLoading: false,
      });
    },
  }));
